import { render, staticRenderFns } from "./CalendarButton.vue?vue&type=template&id=2c4537a2&scoped=true&"
import script from "./CalendarButton.vue?vue&type=script&lang=js&"
export * from "./CalendarButton.vue?vue&type=script&lang=js&"
import style0 from "./CalendarButton.vue?vue&type=style&index=0&id=2c4537a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4537a2",
  null
  
)

export default component.exports